import React, { Component, Fragment } from 'react';
import axios from 'axios'

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
//import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import Error from '../helper/Error';
import SimpleTable from '../helper/SimpleTable';
import DeleteDialog from '../helper/Dialogs';

import TrainingProvWorkshop from './TrainingProvWorkshop'

class TrainingProvider extends Component {
    constructor(props) {
        super(props);

        this.manageMembers = this.props.match.path.includes("members");

        this.token = sessionStorage.getItem('accessToken');
        this.username = JSON.parse(sessionStorage.getItem("user")).username;
        this.submitting = false;
        this.state = {
            name:'',
            email: '',
            users: [],
            info: null,
            error: null,
            selectedUser: undefined,
            members: [],
            groupContact: undefined,
            locID: undefined,
            isDeleteDialogOpen: false,
            itemToDelete: '',
            loading: false,
            groupName: ''
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSelectChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    onUserSelect = (name, value) => {
        let selected = value;

        if (selected === null) {
            this.setState({
                selectedUser: ''
            });
            return;
        }

        this.setState({ selectedUser: JSON.parse(JSON.stringify(selected)) });
    }

    validate = (event) => {
        let addForm = document.querySelector("#form");
        addForm.reportValidity();
        if (addForm.checkValidity() === false) {
            return false;
        }
        return true;
    }

    hideInfo = () => {
        this.setState({ info: '' })
    }


    setError = (err) => {
        this.setState({ error: err.message });
    }

    onSearch = (event) => {
        axios.get('/api/user/search?email=' + this.state.email, {
        }).then(((result) => {
            result = result.data;
            let users = [];

            if (result.users.length > 0) {
                result.users.map((u) =>
                    users.push({ label: u.last_name + ', ' + u.first_name + ' - ' + u.username , value: u.username })
                );

                this.setState({
                    selectedUser: undefined,
                    users: users,
                    info: ""
                });
            } else {
                this.setState({
                    selectedUser: undefined,
                    users: [],
                    info: "User account not found. Check email or ask this person to create an account."
                });
            }
        })).catch(error => {
            console.log("error:" + error);
        });
    }

    onAddMember = (event) => {
        event.preventDefault()

        
        let selectedUser =  this.state.selectedUser['value']
        let alreadyInGroup = this.state.members.find((u) => u.id === selectedUser);
        if (alreadyInGroup) {
            this.setState({ error: "this user is already an admin in this training provider" });
             return
        }
        console.log(this.submitting)

        if (this.submitting) 
            return;

        this.submitting = true;
                console.log(this.submitting)

        let data = {
            groupID: this.state.groupID,
            groupContact: this.state.groupContact,
            groupType: 'Training Provider',
            username: this.state.selectedUser['value'],
            memberType: 'Member', //TODO: change to a select field
            addedBy: this.username
        }
        axios('/api/groupuser/', {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': this.token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            let url = '/api/groupuser/users/' + this.state.groupID;
            axios.get(url, {

            }).then(res => res.data)
                .then(result => {
                    this.setState({
                        members: result.users,
                        email: '',
                        selectedUser: undefined,
                        users: []
                    });
                    this.submitting = false

                });
        }).catch(err => {
            this.setState({ error: err.message });
            this.submitting = false
        });
    }

    onSetDefaultGontact = (tag) => {
        // event.preventDefault();
        let userid = tag;
        var data = {
            groupContact: userid,
        }

        let token = sessionStorage.getItem('accessToken');
        axios('/api/usergroup/setContact/' + this.state.groupID, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {

            if (response.status >= 400) {
                throw new Error(response.statusText);
            }

            this.setState({
                groupContact: userid
            });
        }).catch(err => {
            this.setState({ error: err.message });
        });

    }

    openDeleteDialog = (tag) => {
        this.setState({ itemToDelete: tag });
        this.handleDeleteDialogOpen();
    }

    onRemoveMember = (event) => {
        // event.preventDefault();
        // get the groupuser id
        this.handleDeleteDialogClose();
        let username = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });

        // let uID = event.currentTarget.getAttribute('data-tag');
        let url = '/api/groupuser/' + this.state.groupID + '/' + username;
        axios(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': this.token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            let url = '/api/groupuser/users/' + this.state.groupID;
            axios(url, {
                method: 'GET'
            })
                .then(res => res.data)
                .then(result => {
                    this.setState({
                        members: result.users
                    });
                });
        }).catch(err => {
            this.setState({ error: err.message });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    onSelectChange = (name, value) => {
        this.setState({ [name]: value });
    }

    handleOptionChange = event => {
        if (event.target.value === 'isPublic') {
            this.setState({ [event.target.name]: true });
        } else {
            this.setState({ [event.target.name]: false });
        }
    }

    componentDidMount() {

        ValidatorForm.addValidationRule('isValueSelected', (value) => {
            if (value === undefined) {
                return false;
            }
            return true;
        });
        
        if (this.props.match.params.id === undefined) {
            this.setState({
                id: undefined,
                name: '',
                administrator: '',
                members: []
            });
        } else {
            this.setState({
                groupID: this.props.match.params.id
            });

            axios.get('/api/userGroup/' + this.props.match.params.id, {
            }).then((res) => {
                let group = res.data;
                this.setState({
                    groupContact: group.usergroup.contact,
                    groupName: group.usergroup.name,
                    loading: true
                });
            }).catch(error => {
                this.setState({ error: error.message });
            });

            
            if (this.manageMembers) {
                let url = '/api/groupuser/users/' + this.props.match.params.id;
                axios(url, {
                    method: 'GET'
                }).then(res => res.data)
                .then(result => {
                    this.setState({
                        members: result.users
                    });
                }).catch(error => {
                    this.setState({ error: error.message });
                });
            }
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    renderManageMembers(classes) {
        // if (this.state.error) {
        //     <div>
        //         <br />
        //         <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
        //         <br />
        //     </div>
        // }

    //    if (this.state.error !== null) return <Error />;

        if (this.state.members.length === 0) return <Loading />;

        let enhancedData = [];
        enhancedData = this.state.members.map((arrayItem) => {
            let item = JSON.parse(JSON.stringify(arrayItem));
            item.isGroupContact = (item.id === this.state.groupContact) ? 'Yes' : 'No';
            item.actionsDisabled = {
                makeDefaultContact: (item.id === this.state.groupContact),
                delete: item.id === this.state.groupContact
            }
            return item;
        });
        console.log('enhanced table', enhancedData)

        const tableCells = [
            { id: 'name', label: 'Name', centered: false },
            {id: 'id', label: 'Username', centered: false},
            { id: 'email', label: 'Email', centered: false },
            { id: 'isGroupContact', label: 'Primary Contact?', centered: true },  
        ];

        const actionButtons = [
            { icon: "makeDefaultContact", label:'Make Primary', action: this.onSetDefaultGontact, delete: false },
            { icon: "delete", label:'Delete', action: this.openDeleteDialog, delete: true }
        ];

        return (
            <Fragment>
                {
                    this.state.error
                    ?
                    <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                    :
                    <></>
                }
                {
                    this.state.loading
                    ?
                    <>
                         <PageHeader
                    title={"Manage Training Provider Admin for " + this.state.groupName }
                    cancel={this.props.history.goBack}
                />
                <Grid container  justifyContent="space-around"  alignItems="center">
                    <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                        <p>All Training Provider Admins will be able to:</p>
                        <ul>
                            <li>Add or remove other users</li>
                            <li>Add, edit or cancel classes for this Training Provider</li>
                            <li>Add new contact and location templates</li>
                            <li>Request updates to existing templates</li>
                        </ul>
                        <p>Admins must all have their own GI-BMP log-in, but do not have to be Certified Instructors.</p>
                    </Grid>
                </Grid>
                 <h6>
                    Enter email address, then click search. Select name from the list, then click Add Admin</h6>
                <ValidatorForm
                    noValidate
                    onSubmit={ this.onAddMember}
                >

                    {this.state.info &&
                        <div>
                            <Alert severity="error" onClose={this.hideInfo}>{this.state.info}</Alert>
                            <br />
                        </div>
                    }

                    <Grid container spacing={3}>
                        <Grid item xs={12}  md={4}>
                            <TextValidator
                                label="Enter email to search for account"
                                type="email"
                                name='email'
                                value={this.state.email}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required', 'isEmail']}
                                errorMessages={['Email is required', 'Please enter a valid email address']}
                                fullWidth
                                required
                            />
                        </Grid>
                      
                        <Grid item xs={12}  md={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button 
                            variant="contained" 
                            color="primary" 
                            className={[].join(' ')} 
                            onClick={ this.onSearch}
                        >
                            Search
                            </Button>
                        </Grid>
                        <Grid item xs={12}  md={4}>
                            <Autocomplete
                                id="user"
                                options={this.state.users}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, val) => val === "" || option.value === val}
                                value={this.state.selectedUser || { label: "" }}
                                onChange={this.onUserSelect}
                                className={[classes.autoComplete].join(' ')}
                                renderInput={(params) => <TextValidator {...params}
                                    label="Select user account to add"
                                    value={this.state.users.length === 0 ? "-" : this.state.selectedUser}
                                    validators={['required', 'isValueSelected']}
                                    errorMessages={['Please select an account', 'Please select a user account']}
                                    required
                                />}
                                disabled={this.state.users.length === 0}
                            />
                        </Grid>
                        <Grid item xs={12}  md={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button 
                            variant="contained" 
                            color="primary" 
                            className={[].join(' ')} 
                            disabled={ this.state.selectedUser === undefined}
                            type="submit" 
                            >
                            Add Admin
                            </Button>
                        </Grid>

                    </Grid>

                    <br /><br />

                    <SimpleTable
                        data={enhancedData}
                        cellKey={"id"}
                        tableCells={tableCells}
                        actionButtons={actionButtons}
                        actions={true}
                    />
                    <DeleteDialog
                        open={this.state.isDeleteDialogOpen}
                        onClose={this.handleDeleteDialogClose}
                        onDelete={this.onRemoveMember}
                    />
                </ValidatorForm>
                    </>
                    :
                    <>
                    </>
                }
               
            </Fragment>
        );
    }


    renderOptions(classes) {
        if (this.manageMembers) {
            return this.renderManageMembers(classes);
        }
        //all else
        else {
            return(
            <TrainingProvWorkshop
                setError={this.setError}
                goBack={this.props.history.goBack}
                classes={classes}
                ID={this.props.match.params.id}
                user={this.props.match.params.username}
                token={this.token}
                admin={this.props.admin}
            />)
        }
    }
    render() {
        const { classes } = this.props;

        return (
            this.renderOptions(classes)
        );
    }
}


export default withStyles(styles, { withTheme: true })(TrainingProvider);
